import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { fetchDeliveryOrdersSummary } from '../fetch/fetchStats';
import { DailyDeliveryOrdersSummary } from '../types/statsTypes';

export function useGetOrderDeliverySummary(): {
  deliveryOrdersSummary: DailyDeliveryOrdersSummary;
  isLoading: boolean;
} {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [deliveryOrdersSummary, setDeliveryOrdersSummary] =
    useState<DailyDeliveryOrdersSummary>(null);
  useEffect(() => {
    const fetchTodayOrdersCount = async () => {
      const today = dayjs();
      const deliveryOrders = await fetchDeliveryOrdersSummary(today, today);

      setDeliveryOrdersSummary(deliveryOrders);
      setIsLoading(false);
    };

    fetchTodayOrdersCount();
  }, [setDeliveryOrdersSummary, setIsLoading]);

  return { deliveryOrdersSummary, isLoading };
}
